const adminData = {
    en: {
        adminBadge: 'Admin',
        dashboardTitle: 'Dashboard',
        stats: {
            revenue: 'Total Revenue',
            orders: 'Total Orders',
            customers: 'Customers',
            avgOrder: 'Avg Order',
        },
        chart: {
            eyebrow: 'Revenue Over Time',
            title: 'Order Flow',
            lastDays: (n) => `Last ${n} days`,
        },
        ordersTable: {
            eyebrow: 'Latest Activity',
            title: 'Recent Orders',
            total: (n) => `${n} total`,
            headers: ['Items', 'Customer', 'Status', 'Total', 'Date'],
            activeEyebrow:    'In Progress',
            activeTitle:      'Active Orders',
            completedEyebrow: 'Fulfilled',
            completedTitle:   'Completed Orders',
            failedEyebrow:    'Attention Needed',
            failedTitle:      'Failed Payments',
        },
        statusLabels: {
            paid:               'Paid',
            received:           'Received',
            processing:         'Processing',
            ready_for_shipping: 'Ready for Shipping',
            ready_for_pickup:   'Ready for Pickup',
            shipped:            'Shipped',
            picked_up:          'Picked Up',
            delivered:          'Delivered',
            done:               'Done',
            payment_failed:     'Payment Failed',
        },
        usersTable: {
            eyebrow: 'Registry',
            title: 'Customers',
            registered: (n) => `${n} registered`,
            headers: ['Name', 'Email', 'Orders', 'Phone'],
        },
        contentEditor: {
            eyebrow: 'Content Editor',
            inventoryLabel: 'Inventory',
            noPreview: 'No Preview',
        },
        orderDetail: {
            eyebrow: 'Order Detail',
            backLabel: 'Back to Dashboard',
            customerLabel: 'Customer',
            dateLabel: 'Date',
            itemsLabel: 'Items',
            totalLabel: 'Total',
            statusLabel: 'Order Status',
            updateBtn: 'Update Status',
            updating: 'Updating...',
            updateSuccess: 'Status updated',
            updateError: 'Failed to update',
            noItems: 'No items in this order',
            printLabel: 'Print Label',
            printing: 'Printing...',
            printSuccess: 'Sent to printer',
            printError: 'Print failed',
            noLabelUrl: 'No shipping label available',
            buyLabelBtn: 'Buy Label',
            buyingLabel: 'Buying...',
            buyLabelSuccess: 'Label ready — refresh to print',
            buyLabelError: 'Failed to buy label',
            noShipmentId: 'No EasyShip shipment on this order',
        },
        printers: {
            title:       'Printers',
            eyebrow:     'PrintNode',
            loadBtn:     'Load Printers',
            loading:     'Loading...',
            empty:       'No printers found',
            colId:       'ID',
            colName:     'Name',
            colState:    'State',
            colComputer: 'Computer',
            testBtn:     'Test',
            testOk:      'Sent!',
            testFail:    'Failed',
            defaultBadge: 'Default',
        },
        products: {
            title: 'Edit Products',
            openEditor: 'Open Editor',
            totalCount: 'Total Products',
        },
        configurations: {
            eyebrow: 'System',
            title: 'Runtime Configurations',
            entries: 'entries',
            loading: 'Loading...',
            fields: { key: 'Key', value: 'Value', label: 'Label', description: 'Description' },
            placeholders: { key: 'e.g. products.source', value: 'e.g. s3 or zoho', label: '', description: '' },
            saveBtn: 'Save',
            cancelBtn: 'Cancel',
            editBtn: 'Edit',
            deleteBtn: 'Delete',
            createBtn: 'Create',
            addBtn: '+ Add Configuration',
            deleteConfirm: (key) => `Are you sure you want to delete the configuration "${key}"?\n\nThis action cannot be undone.`,
        },
        systemSections: {
            edit: 'Edit',
            items: 'Items',
        },
        restock: {
            eyebrow: 'Admin',
            title: 'Restock Configuration',
            description: 'Toggle restock mode per category. When active, visitors see a "Back in Stock Soon" page instead of products.',
            restockActive: 'Restock Active',
            noCategories: 'No categories loaded.',
        },
        logs: {
            title: 'System Log',
            placeholders: {
                lines: 'Lines',
                filter: 'Filter by keyword',
            },
            actions: {
                refresh: 'Refresh',
                loading: 'Loading...',
            },
            timeRanges: {
                fiveMin: '5 Minutes',
                oneHour: '1 Hour',
                fourHours: '4 Hours',
                allDay: 'All Day',
            },
            emptyState: 'No logs to display',
            footerNote: 'Admin login recorded on',
        },
    },
    he: {
        adminBadge: 'מנהל',
        dashboardTitle: 'לוח ניהול',
        stats: {
            revenue: 'סה"כ הכנסות',
            orders: 'סה"כ הזמנות',
            customers: 'לקוחות',
            avgOrder: 'ממוצע הזמנה',
        },
        chart: {
            eyebrow: 'הכנסות לאורך זמן',
            title: 'זרימת הזמנות',
            lastDays: (n) => `${n} ימים אחרונים`,
        },
        ordersTable: {
            eyebrow: 'פעילות אחרונה',
            title: 'הזמנות אחרונות',
            total: (n) => `${n} סה"כ`,
            headers: ['פריטים', 'לקוח', 'סטטוס', 'סכום', 'תאריך'],
            activeEyebrow:    'בטיפול',
            activeTitle:      'הזמנות פעילות',
            completedEyebrow: 'טופל',
            completedTitle:   'הזמנות שהושלמו',
            failedEyebrow:    'דורש טיפול',
            failedTitle:      'תשלומים שנכשלו',
        },
        statusLabels: {
            paid:               'שולם',
            received:           'התקבל',
            processing:         'בעיבוד',
            ready_for_shipping: 'מוכן למשלוח',
            ready_for_pickup:   'מוכן לאיסוף',
            shipped:            'נשלח',
            picked_up:          'נאסף',
            delivered:          'נמסר',
            done:               'הושלם',
            payment_failed:     'תשלום נכשל',
        },
        usersTable: {
            eyebrow: 'רישום',
            title: 'לקוחות',
            registered: (n) => `${n} רשומים`,
            headers: ['שם', 'אימייל', 'הזמנות', 'טלפון'],
        },
        contentEditor: {
            eyebrow: 'עורך תוכן',
            inventoryLabel: 'מלאי',
            noPreview: 'אין תצוגה מקדימה',
        },
        orderDetail: {
            eyebrow: 'פרטי הזמנה',
            backLabel: 'חזרה ללוח הניהול',
            customerLabel: 'לקוח',
            dateLabel: 'תאריך',
            itemsLabel: 'פריטים',
            totalLabel: 'סכום',
            statusLabel: 'סטטוס הזמנה',
            updateBtn: 'עדכן סטטוס',
            updating: 'מעדכן...',
            updateSuccess: 'הסטטוס עודכן',
            updateError: 'עדכון נכשל',
            noItems: 'אין פריטים בהזמנה',
            printLabel: 'הדפס תווית',
            printing: 'מדפיס...',
            printSuccess: 'נשלח למדפסת',
            printError: 'ההדפסה נכשלה',
            noLabelUrl: 'אין תווית משלוח',
            buyLabelBtn: 'רכוש תווית',
            buyingLabel: 'רוכש...',
            buyLabelSuccess: 'תווית מוכנה — רענן להדפסה',
            buyLabelError: 'רכישת תווית נכשלה',
            noShipmentId: 'אין משלוח EasyShip בהזמנה',
        },
        printers: {
            title:       'מדפסות',
            eyebrow:     'PrintNode',
            loadBtn:     'טען מדפסות',
            loading:     'טוען...',
            empty:       'לא נמצאו מדפסות',
            colId:       'מזהה',
            colName:     'שם',
            colState:    'מצב',
            colComputer: 'מחשב',
            testBtn:     'בדיקה',
            testOk:      'נשלח!',
            testFail:    'נכשל',
            defaultBadge: 'ברירת מחדל',
        },
        products: {
            title: 'עריכת מוצרים',
            openEditor: 'פתח עורך',
            totalCount: 'סה"כ מוצרים',
        },
        configurations: {
            eyebrow: 'מערכת',
            title: 'הגדרות זמן ריצה',
            entries: 'רשומות',
            loading: 'טוען...',
            fields: { key: 'מפתח', value: 'ערך', label: 'תווית', description: 'תיאור' },
            placeholders: { key: 'לדוגמה: products.source', value: 'לדוגמה: s3 או zoho', label: '', description: '' },
            saveBtn: 'שמור',
            cancelBtn: 'ביטול',
            editBtn: 'עריכה',
            deleteBtn: 'מחק',
            createBtn: 'צור',
            addBtn: '+ הוסף הגדרה',
            deleteConfirm: (key) => `האם למחוק את ההגדרה "${key}"?\n\nלא ניתן לבטל פעולה זו.`,
        },
        systemSections: {
            edit: 'עריכה',
            items: 'פריטים',
        },
        restock: {
            eyebrow: 'מנהל',
            title: 'הגדרת חידוש מלאי',
            description: 'הפעל/כבה מצב "חידוש מלאי" לפי קטגוריה. כשפעיל, המבקרים רואים עמוד "חוזר למלאי בקרוב" במקום מוצרים.',
            restockActive: 'חידוש מלאי פעיל',
            noCategories: 'לא נטענו קטגוריות.',
        },
        logs: {
            title: 'יומן מערכת',
            placeholders: {
                lines: 'שורות',
                filter: 'סינון לפי מילת מפתח',
            },
            actions: {
                refresh: 'רענן',
                loading: 'טוען...',
            },
            timeRanges: {
                fiveMin: '5 דקות',
                oneHour: 'שעה',
                fourHours: '4 שעות',
                allDay: 'כל היום',
            },
            emptyState: 'אין לוגים להצגה',
            footerNote: 'כניסת מנהל הוקלטה בתאריך',
        },
    },
};

export function getAdminStrings(language) {
    return adminData[language] || adminData.en;
}

export default adminData;
